import { CreateSubscriptionData, Subscription, UpdateSubscriptionData } from '@/domains/subscription';
import { authorizedApi } from '../network/authorized-api';
import { Page } from '@/domains';
import { getMeals } from './meals';

export const getSubscriptions = (
  userId: string,
  onlyActive: boolean,
  page: number,
  pageSize: number
): Promise<Page<Subscription>> =>
  authorizedApi.get('/admin/subscriptions', {
    userId,
    onlyActive,
    pageNumber: page,
    pageSize: pageSize
  });

export const getSubscriptionTypes = () => {
  const VENDOR_ID = '62ded4c81070f24eb794ac67';
  return getMeals(VENDOR_ID, { page: 1, size: 20, term: '', type: 'SUBSCRIPTION' });
};

export const createSubscription = (data: CreateSubscriptionData): Promise<void> =>
  authorizedApi.post('/admin/subscriptions', data);

export const updateSubscription = (id: string, data: UpdateSubscriptionData): Promise<void> =>
  authorizedApi.patch(`/admin/subscriptions/${id}`, data);
